import { FC } from "react";
import { observer } from "mobx-react";
import { ApproveAnnualAccountForm } from "./approveAnnualAccountDomain";
import { FromToPeriod, NumberQuestion, YesNoQuestion } from "../common/commonComponents";
import { VBox } from "../../components-v2/Box";

import { useTranslation } from "../../stores/RootStoreContext";

export const ApproveAnnualAccountView: FC<{ form: ApproveAnnualAccountForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();

    return (
      <VBox gap={"md"}>
        <YesNoQuestion
          question={t("decisions.approveAnnualAccount.deviating-accounting-year")}
          field={form.isDeviatingPeriod}
          isLocked={form.isProjectLocked}
        />
        {form.isDeviatingPeriod.value && (
          <FromToPeriod
            label={t("decisions.approveAnnualAccount.what-accounting-period")}
            from={form.deviatingPeriodFrom}
            to={form.deviatingPeriodTo}
            isLocked={form.isProjectLocked}
          />
        )}
        {!form.isDeviatingPeriod.value && (
          <NumberQuestion
            question={t("decisions.approveAnnualAccount.what-accounting-year")}
            field={form.period}
            isLocked={form.isProjectLocked}
          />
        )}
        <YesNoQuestion
          question={t("decisions.approveAnnualAccount.company-small.question")}
          field={form.isSmallBusinesses}
          isLocked={form.isProjectLocked}
          infoText={t("decisions.approveAnnualAccount.company-small.infoText")}
          fieldName={"approveAnnualReport"}
        />
        <YesNoQuestion
          question={t("decisions.approveAnnualAccount.approve-consolidated-accounts", {
            companyName: "",
          })}
          field={form.isGroup}
          isLocked={form.isProjectLocked}
          fieldName={"approveConsolidatedAccounts"}
        />
      </VBox>
    );
  },
);
